import { render } from "./SuccessOnboardingPage.vue?vue&type=template&id=8b47e82c"
import script from "./SuccessOnboardingPage.vue?vue&type=script&lang=js"
export * from "./SuccessOnboardingPage.vue?vue&type=script&lang=js"

import "./SuccessOnboardingPage.vue?vue&type=style&index=0&id=8b47e82c&lang=css"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__